import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    safeZone: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for safe zone toggle */
            safeZone: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FooterControls.safeZone?c=dy72hn987znt", defaultMessage: "Safe zone" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
